<template>
  <div class="sg-order-detail">
    <div class="header-bg">
      <div class="status-con">

        <div class="status-wait">
          <div class="status-info-con" v-if="info.orderStatus==='WAIT' && timeText">
            <div class="text">等待付款</div>
            <div class="time-text">剩余 {{ timeText }} 自动关闭</div>
          </div>
          <div class="status-info-con" v-if="info.orderStatus==='PAID'">
            <div class="text" style="line-height: 40px;">等待买家收货</div>
          </div>
          <div class="status-info-con" v-if="info.orderStatus==='FINISH'">
            <div class="text" style="line-height: 40px;">购买成功</div>
          </div>
          <div class="status-info-con" v-if="info.orderStatus==='CANCELLED'">
            <div class="text" style="line-height: 40px;">购买取消</div>
          </div>
          <div class="status-info-con" v-if="info.orderStatus==='TIMEOUT'">
            <div class="text" style="line-height: 40px;">订单已超时</div>
          </div>

          <div class="btn-con">
            <div class="btn" v-if="info.orderStatus==='WAIT' && timeText" @click="goPay">去支付</div>
            <div class="btn" v-if="info.orderStatus==='FINISH'||info.orderStatus==='CANCELLED'||info.orderStatus==='TIMEOUT'" @click="gobuyAgain">再次购买</div>
          </div>
        </div>


        <div class="status-paid" v-if="info.orderStatus==='PAID'">
          <div class="status-info-con">
            <div class="text">等待收货</div>
            <!--<div class="time-text">剩余 {{ timeText }} 自动关闭</div>-->
          </div>
        </div>
      </div>
      <div class="addr-con" v-if="info.orderStatus==='WAIT'||info.orderStatus==='CANCELLED'||info.orderStatus==='TIMEOUT'">
        <div class="icon-con"><div class="icon"></div></div>
        <div class="addr-info" v-if="addr.userAddressId">
          <div class="name-con">
            <span class="name">{{ addr.addresseeName }}</span>
            <span class="phone">{{ addr.addresseeTel }}</span>
          </div>
          <div class="addr-text">{{ addr.fullArea + addr.detailAddress }}</div>
        </div>
      </div>
      <div class="logistics-con" v-if="info.orderStatus==='PAID'||info.orderStatus==='FINISH'">
        <div class="icon-con"><div class="icon"></div></div>
        <div class="logistics-info" @click="goSgOrderTrack">
          <div class="logistics-text">{{ contentText }}</div>
        </div>
        <div class="right-con" @click="goSgOrderTrack"><span class="icon"></span></div>
      </div>
    </div>
    <div class="bg-10px"></div>

    <div class="addr-con-paid" v-if="info.orderStatus==='PAID'||info.orderStatus==='FINISH'">
      <div class="icon-con"><div class="icon"></div></div>
      <div class="addr-info" v-if="addr.userAddressId">
        <div class="name-con">
          <span class="name">{{ addr.addresseeName }}</span>
          <span class="phone">{{ addr.addresseeTel }}</span>
        </div>
        <div class="addr-text">{{ addr.fullArea + addr.detailAddress }}</div>
      </div>
    </div>
    <div class="order-goods">
      <shop-item
          v-for="(item, i) in info.shopOrders"
          :itemData="item"
          :key="item.shopId"
      ></shop-item>
    </div>

    <div class="order-info">
      <div class="info-header"><span class="icon"></span><span>订单信息</span></div>
      <div class="text-list-con">
        <div class="list"><span class="left">订单编号:</span><span class="right">{{ info.orderMergeId }}</span></div>
        <div class="list"><span class="left">下单时间:</span><span class="right">{{ info.gmtCreate }}</span></div>
        <div class="list" v-if="info.orderStatus==='PAID'||info.orderStatus==='FINISH'"><span class="left">支付方式:</span><span class="right">{{ payWayText(info.payWay) }}</span></div>
        <div class="list" v-if="info.orderStatus==='PAID'||info.orderStatus==='FINISH'"><span class="left">支付时间:</span><span class="right">{{ info.paySuccessTime }}</span></div>
        <div class="list" v-if="(info.orderStatus==='PAID'||info.orderStatus==='FINISH')&&packageList.length>0"><span class="left">配送方式:</span><span class="right">{{ packageList[0].logisticsName }}</span></div>
        <div class="list" v-if="info.orderStatus==='PAID'&&packageList.length>0&&packageList[0].wishDeliveryTimeSmall"><span class="left">期望配送时间:</span><span class="right">{{ packageList[0].wishDeliveryTimeSmall }}</span></div>
      </div>
    </div>
    <div class="bg-10px"></div>
    <div class="price-con">
      <div class="price-header">
        <div class="left"><span class="icon"></span><span>商品总额</span></div>
        <div class="right">￥{{ info.totalAmount && (info.totalAmount-info.freight).toFixed(2) }}</div>
      </div>
      <div class="price-list">
        <div class="list">
          <div class="left">运费</div>
          <div class="right">{{ info.freight>0 ? info.freight.toFixed(2) : '免运费' }}</div>
        </div>
        <div class="list actual">
          <div class="left">实付款</div>
          <div class="right">￥{{ info.totalAmount && info.totalAmount.toFixed(2) }}</div>
        </div>

      </div>
    </div>
    <div class="bg-10px"></div>

    <div class="bottom-con">
      <div class="btn" v-if="info.orderStatus==='PAID'" @click="goSgOrderTrack">查看物流</div>
      <div class="btn" v-if="info.orderStatus==='WAIT' && timeText" @click="cancelOrder">取消订单</div>
      <div class="btn to-pay" v-if="info.orderStatus==='WAIT' && timeText" @click="goPay">去支付</div>
      <!--<div class="btn go-evaluated" v-if="info.orderStatus==='FINISH'&&info.isEvaluated===false" @click="goEvaluated">立即评价</div>-->
    </div>

  </div>
</template>

<script>
import { getPaySignInfo } from '@/api/pay/payApi'
import { addressDetail } from '@/api/mall/mallLogistics'
import { getJDOrderTrack } from '@/api/mall/mallJD'
import { sgOrderInfo, deliveryList, cancelOrder } from '@/api/mall/mallOrder'
import shopItem from './components/shopItem/index'
export default {
  components: {
    shopItem,
  },
  data(){
    return {
      info: {},
      addr: {},
      latestPayTime: '',//最后支付时间
      timer: null,
      timeText: '',
      packageList: [],//包裹信息
      trackMap: {},//物流信息
      jdOrderId: '',//最新物流信息id
      contentText: '',//最新物流信息

      canClick: true,

    }
  },
  created(){
    this.getSgOrderInfo()
  },
  methods: {
    //订单详情
    getSgOrderInfo(){
      sgOrderInfo({orderMergeId: this.$route.query.orderMergeId}).then(res=>{
        if(res.code===200){
          this.info = res.data
          if(res.data.orderStatus==='WAIT'){//待支付
            this.latestPayTime = new Date(res.data.latestPayTime)
            if(Date.now() < this.latestPayTime){//若未到最后支付时间
              this.countDown()
              this.timer = window.setInterval(()=>{
                this.countDown()
              },1000)
            }
          }else if(res.data.orderStatus==='PAID'||res.data.orderStatus==='FINISH'){//已支付
            this.deliveryList(res.data.orderMergeId)
          }
          this.getAddressDetail(res.data.userAddressId)
        }else {
          this.$toast(res.message)
        }
      })
    },
    getAddressDetail(userAddressId){
      addressDetail({userAddressId}).then(res=>{
        if(res.code===200){
          this.addr = res.data
        }
      })
    },

    //再次购买
    gobuyAgain(){
      let shopList = this.info.shopOrders
      let data = {items: []};
      shopList.map(item=>{
        item.goodsList.map(item2=>{
          data.items.push({
            goodsId: item2.goodsId,
            goodsType: item2.goodsType,
            priceWhenAdded: item2.unitAmount,
            productCode: item2.productCode,
            productCount: item2.goodsCount,
            productId: item2.productId,
            shopId: item.shopId,
            shopSysType: item.shopSysType
          })
        })
      })
      console.log(data)
      this.$store.dispatch('sg/addBuyCart', data).then(()=>{
        this.$router.push({name: 'shoppingCart'})
      })
    },

    //评论页
    goEvaluated(){
      let list = []
      this.info.shopOrders.map(item=>{
        item.goodsList.map(item2=>{
          list.push({
            shopId: item.shopId,
            goodsId: item2.goodsId,
            goodsName: item2.goodsName,
            goodsImage: item2.goodsImage,
            goodsType: item2.goodsType,
            orderMergeId: this.info.orderMergeId
          })
        })
      })


      this.session('evaluatedGoods', list)
      this.$router.push({name: 'sgOrderEvaluated'})
    },

    //去支付
    goPay(){
      let obj = {
        orderId: this.info.orderMergeId,
        orderNo: this.info.payOrderNo,
        totalAmount: this.info.totalAmount,
        pageFrom: this.$route.fullPath
      }
      this.session('sgConfirmOrderPay', obj)
      // console.log(obj)
      this.$router.push({name: 'sgConfirmOrderPay'})
    },

    //取消订单
    cancelOrder(){
      // console.log(this.item.payOrderNo)
      this.$dialog.confirm({
        message: '您确认要取消该订单吗？'
      }).then(() => {
        cancelOrder({orderNo: this.info.payOrderNo}).then(res=>{
          if(res.code===200){
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },

    // 获取物流包裹信息
    deliveryList(orderMergeId){
      deliveryList({orderMergeId}).then(res=>{
        let data = res.data || []
        if(data.length){
          data.map(item=>{
            this.packageList.push(item)
            this.getJDOrderTrack(item.deliveryOrderId)
          })
        }
      })
    },
    //  获取物流配送信息
    getJDOrderTrack(jdOrderId){
      getJDOrderTrack({jdOrderId,waybillCode: 1}).then(res=>{
        if(res.code===200){
          this.trackMap[res.data.jdOrderId] = res.data
          this.jdOrderId = res.data.jdOrderId
          this.contentText = res.data.orderTrack[res.data.orderTrack.length-1].content
        }
      })
    },
    //跳转至物流详情
    goSgOrderTrack(){
      this.$router.push({name: 'sgOrderTrack', query: {jdOrderId: this.jdOrderId}})
    },

    //倒计时
    countDown(){
      let nowDown = parseInt((this.latestPayTime - Date.now())/1000)
      if(nowDown>0){
        let time = parseInt(nowDown/3600)
        let minute = parseInt((nowDown%3600)/60)
        let second = parseInt((nowDown%3600%60))
        this.timeText = (time+'小时'+minute+'分钟')
        if(time===0&minute===0){
          this.timeText = second+'秒'
        }
        // console.log(this.timeText)
      }else {
        window.clearInterval(this.timer)
        this.timer = null
        window.setTimeout(()=>{
          this.$router.go(0)
        },1000)
      }
    },
    //支付方式
    payWayText(type){
      let text = ''
      switch (type){
        case 'ALIPAY':
          text = '支付宝'
          break;
        case 'WECHAT_PAY':
          text = '微信支付'
          break;
        case 'BALANCE':
          text = '钱包余额支'
          break;
        case 'FREE':
          text = '免费订单，无需支付'
          break;
        case 'ANTPAY':
          text = '金币支付'
          break;
        default:
          text = '其他支付方式'
          break;
      }
      return text
    },
  }
}
</script>

<style lang="less" scoped>
.sg-order-detail{
  position: relative;width: 100%;height: 100%;overflow: auto;font-size: 14px;padding-bottom: 50px;
  .header-bg{
    width: 100%;height: 152px;position: relative;
    background-image: linear-gradient(to right, rgb(30,101,240), rgb(1,200,249));
    .status-con{
      position: absolute;top: 0;bottom: 84px;left: 0;right: 0;z-index: 0;
      .status-wait, .status-paid{
        display: flex;
        .status-info-con{
          color: #fff;
          flex: 1;height: 68px;padding: 15px 0 15px 50px;
          display: inline-flex;flex-direction: column;
          justify-content: space-between;align-items: flex-start;
          .text{font-size: 16px;line-height: 1;}
          .time-text{font-size: 13px;line-height: 1;}
        }
      }
      .status-wait{
        .btn-con{
          width: 128px;height: 68px;display: inline-flex;justify-content: flex-start;align-items: center;
          .btn{
            width: 98px;height: 30px;display: inline-flex;justify-content: center;align-items: center;
            border-radius: 15px;background-color: #fff;color: #1585f3;
          }
        }

      }

    }
    .addr-con{
      position: absolute;left: 0;right: 0;bottom: 0;background-color: #fff;
      border-top-left-radius: 15px;border-top-right-radius: 15px;height: 84px;
      display: flex;
      .icon-con{
        width: 50px;height: 60px;display: inline-flex;justify-content: center;align-items: center;
        .icon{
          width: 29px;height: 29px;
          background: url("../../../assets/my/sgOrder/addr-icon-select.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
      .addr-info{
        flex: 1;height: 84px;display: flex;flex-direction: column;
        justify-content: space-between;padding: 14px 12px 15px 0;
        .name-con{line-height: 1;
          .name{color: #333;font-size: 13px;padding-right: 10px;}
          .phone{color: #999;font-size: 12px;}
        }
        .addr-text{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
        }
       }
    }
    .logistics-con{
      position: absolute;left: 0;right: 0;bottom: 0;background-color: #fff;
      border-top-left-radius: 15px;border-top-right-radius: 15px;height: 84px;
      display: flex;
      .icon-con{
        width: 50px;height: 60px;display: inline-flex;justify-content: center;align-items: center;
        .icon{
          width: 32.5px;height: 29.5px;
          background: url("../../../assets/my/sgOrder/logistics-icon.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
      .logistics-info{
        flex: 1;height: 84px;display: flex;flex-direction: column;
        justify-content: center;padding: 0 12px 0 0;
        .logistics-text{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
        }
      }
      .right-con{
        width: 32px;height: 100%;
        display: inline-flex;justify-content: center;align-items: center;
        .icon{
          display: block;width: 8px;height: 16px;
          background: url("../../../assets/my/icon-right.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }
  }
  .addr-con-paid{
    background-color: #fff;border-bottom: 10px solid #f5f5f5;
    height: 84px;
    display: flex;
    .icon-con{
      width: 50px;height: 60px;display: inline-flex;justify-content: center;align-items: center;
      .icon{
        width: 29px;height: 29px;
        background: url("../../../assets/my/sgOrder/addr-icon-select.png") no-repeat 50% 50%;
        background-size: 100%;
      }
    }
    .addr-info{
      flex: 1;height: 84px;display: flex;flex-direction: column;
      justify-content: space-evenly;padding: 14px 12px 15px 0;
      .name-con{line-height: 1;
        .name{color: #333;font-size: 13px;padding-right: 10px;}
        .phone{color: #999;font-size: 12px;}
      }
      .addr-text{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
  .order-goods{}
  .order-info{
    .info-header{
      display: flex;align-items: center;padding-left: 12px;height: 44px;border-bottom: 1px solid #eee;
      .icon{
        background-color: #4f9dff;margin-right: 8px;
        display: inline-flex;width: 2px;height: 12px;
      }
    }
    .text-list-con{
      font-size: 10px;
      .list{
        display: flex;height: 34px;align-items: center;padding-left: 12px;
        .left{width: 82px;color: rgb(153,153,153);}
        .right{flex: 1;color: rgb(51,51,51);}
      }
    }
  }
  .price-con{
    .price-header{
      display: flex;align-items: center;padding-left: 12px;height: 44px;border-bottom: 1px solid #eee;
      .left{
        display: inline-flex;width: 50%;height: 100%;align-items: center;
        .icon{
          background-color: #4f9dff;margin-right: 8px;
          display: inline-flex;width: 2px;height: 12px;
        }
      }
      .right{
        display: inline-flex;flex: 1;height: 100%;justify-content: flex-end;align-items: center;
        font-size: 12px;color: #666;padding-right: 12px;
      }

    }
    .price-list{
      .list{
        display: flex;align-items: center;padding: 0 12px;
        color: #666;height: 40px;border-bottom: 1px solid #eee;
        .left{display: inline-flex;width: 30%;}
        .right{display: inline-flex;flex: 1;justify-content: flex-end;}
        &:last-child{
          border-bottom: none;

        }
      }
      .actual{
        .left{color: #000;}
        .right{color: #f74d4d;font-size: 12px;}
      }
    }
  }
  .bottom-con{
    position: fixed;left: 0;right: 0;bottom: 0;height: 50px;padding-right: 12px;background-color: #fff;
    display: flex;justify-content: flex-end;align-items: center;border-top: .75px solid #efefef;
    .btn{
      display: inline-flex;width: 80px;height: 30px;margin-right: 10px;
      justify-content: center;align-items: center;font-size: 14px;border-radius: 15px;
      border: 1px solid #666;color: #666;background-color: #fff;
      &:last-child{margin-right: 0;}
      &.to-pay{border: 1px solid #f74d4d;color: #fff;background-color: #f74d4d;}
      &.go-evaluated{color: #f74d4d;border-color: #f74d4d;}
    }
  }
}
</style>